import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';

export type TourEvent = {
  id: number;
  sequenceId: number;
  name: string;
  date: string;
  position: PositionGeocode | undefined;
  capacity: number;
  type: TourEventType;
};

export type TourEventType = (typeof TourEventTypeValues)[number];

export const TourEventTypeValues = ['', 'festival', 'venue'] as const;

export type TourEventBasic = Pick<
  TourEvent,
  'name' | 'date' | 'position' | 'capacity'
>;
